import React from 'react';
import { Input } from 'antd';
import classNames from 'classnames';
import styles from './styles.module.less';
/**
 * @description SearchBox component
 * @param {string} styleName
 * @param {string} placeholder
 * @param {function} onChange
 * @param {string} value
 * @param {string} className
 * @param {'search' | 'text'} type
 * @returns
 */
const SearchBox = ({
  styleName = '',
  placeholder,
  onChange,
  value = '',
  className,
  type = 'search',
  label = '',
}) => {
  return (
    <div className={classNames(`gx-search-bar ${styleName}`, className)}>
      {label && <label className="gx-guarnic-title-filter ">{label}</label>}
      <div className="gx-form-group">
        {type === 'search' && (
          <Input.Search
            className={`${styles.searchBox} gx-mb-0`}
            placeholder={placeholder}
            onChange={onChange}
            value={value}
          />
        )}
        {type === 'text' && <Input placeholder={placeholder} onChange={onChange} value={value} />}
      </div>
    </div>
  );
};
export default SearchBox;
